// Cognito country label -> short code: ISO 3166-1 alpha-2, except the
// United Kingdom which stays "UK" (house preference). Keys are lower-cased
// and stripped of punctuation. Unknown labels fall back to the label itself.
// Mirrors backend/proposal_view/country_codes.py; keep the two in step.
const ISO = {
  uk: "UK", "united kingdom": "UK", "great britain": "UK", england: "UK", scotland: "UK", wales: "UK",
  us: "US", usa: "US", "united states": "US", "united states of america": "US",
  canada: "CA", mexico: "MX", brazil: "BR", argentina: "AR", chile: "CL", colombia: "CO",
  germany: "DE", france: "FR", spain: "ES", italy: "IT", netherlands: "NL", "the netherlands": "NL",
  belgium: "BE", austria: "AT", switzerland: "CH", ireland: "IE", portugal: "PT", greece: "GR",
  sweden: "SE", denmark: "DK", norway: "NO", finland: "FI", poland: "PL", "czech republic": "CZ",
  czechia: "CZ", hungary: "HU", romania: "RO", turkey: "TR", russia: "RU",
  japan: "JP", china: "CN", taiwan: "TW", "hong kong": "HK", singapore: "SG", "south korea": "KR",
  korea: "KR", india: "IN", australia: "AU", "new zealand": "NZ", vietnam: "VN", thailand: "TH",
  malaysia: "MY", indonesia: "ID", philippines: "PH",
  uae: "AE", "united arab emirates": "AE", ksa: "SA", "saudi arabia": "SA", israel: "IL",
  "south africa": "ZA", egypt: "EG", qatar: "QA",
};

const norm = (s) => (s || "").toLowerCase().replace(/[^a-z\s]/g, "").replace(/\s+/g, " ").trim();

export const isoCountryCode = (label) => ISO[norm(label)] || label;
